import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import {PublicClientApplication} from "@azure/msal-browser";
import {getMsalConfig} from "./aad/authConfig";
import {MsalProvider} from "@azure/msal-react";
import { createRoot } from 'react-dom/client';
import { init as initApm } from '@elastic/apm-rum';
import packageInfo from '../package.json';
import LogRocket from "logrocket";
import setupLogRocketReact from 'logrocket-react';
const msalInstance = new PublicClientApplication(getMsalConfig(document.location.protocol + "//" + document.location.host));
const container = document.getElementById('root');

const root = createRoot(container!);



doInitApm().then(() => {
    root.render(
        <React.StrictMode>
            <React.StrictMode>
                <MsalProvider instance={msalInstance}>
                    <App />
                </MsalProvider>
            </React.StrictMode>,
        </React.StrictMode>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
});

async function doInitApm() {
    /**
     * See https://vitejs.dev/guide/env-and-mode#modes.
     * In our case, this is always "production" when deployed to server.
     * Only localhost is "development".
     * */
    const envMode = process.env.NODE_ENV;

    // Environment type (dev/test/prod)

    const envType = window.location.host.endsWith("bimairedev.app") ? "dev" : "prod";


    const apm = initApm({

        // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
        serviceName: 'vsc-webapp',

        // Set custom APM Server URL (default: http://localhost:8200)
        serverUrl: 'https://e55d7c58975e48d28b29100712ed60b4.apm.us-east-2.aws.elastic-cloud.com:443',

        // Set service version (required for sourcemap feature)
        serviceVersion: packageInfo.version,

        active: envMode !== "development" || true,
        environment: envType.toString(),
        ignoreTransactions: [/logr/, /-\/hub/] //ignore log rocket transactions
    });


    LogRocket.init(`rqymxy/vsc-webapp`);
    setupLogRocketReact(LogRocket);
    /*if (env) {
        apm.addLabels({ customerEnv: env });
    }*/
}




// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
